<div
  class="bg-[#ffffff] md:p-[10px] rounded-md shadow-sm"
  [ngClass]="{ 'md:relative fixed inset-0 z-50 p-[20px]': isPopup() }"
>
  @if (isOriginalGridSlot() || gridViewOnly() || currentReviewDetails()) {
    <div
      class="mb-4 flex justify-between items-center [&>*:only-child]:ml-auto"
    >
      @if (gridViewOnly() && slotData()?.widget?.data?.title) {
        <span class="text-gray-700">{{ slotData()?.widget?.data?.title }}</span>
      }

      @if (isOriginalGridSlot()) {
        <button
          class="flex items-center gap-2 text-gray-700 hover:text-gray-900 transition-colors"
          (click)="backToUserImagesGrid()"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          <span class="text-sm font-medium inline">
            {{ slotData()?.widget?.data?.backToUserImagesText }}
          </span>
        </button>
      }

      <button (click)="popupClose()">
        <img
          width="18"
          height="18"
          [ngSrc]="closePopupIcon()"
          alt="close"
          title="close"
        />
      </button>
    </div>
  }
  <div
    [ngClass]="{
      'md:w-auto w-full h-full flex flex-col justify-start':
        isPopup() && gridViewOnly(),
      'md:w-auto w-full md:h-auto h-full flex flex-col justify-center':
        isPopup() && !gridViewOnly(),
    }"
    class="flex-grow flex item-center"
  >
    <div
      class="w-full flex flex-col gap-6"
      [ngClass]="{
        'md:flex-row md:items-start md:justify-center':
          isPopup() && reviewContextEnabled(),
      }"
    >
      <div class="w-full md:max-w-[700px]">
        <div
          class="md:mt-[11px] bg-[#FFFFFF] md:border-gray-200 rounded-[4px] md:border-solid md:border-[1px] mb-[5px] relative cursor-pointer !border-0"
        >
          @if (!isPopup()) {
            <div
              class="flex items-center absolute top-[0] z-[2] justify-between w-full left-0"
            >
              @if (slotData()?.widget?.data?.offerButton?.clearanceSale) {
                <div
                  class="flex items-center gap-[5px] bg-[#FF0000] rounded p-[4px]"
                >
                  <img
                    height="15"
                    width="15"
                    [ngSrc]="
                      slotData()?.widget?.data?.offerButton?.clearanceSale
                        ?.image
                    "
                    [title]="
                      slotData()?.widget?.data?.offerButton?.clearanceSale
                        ?.title
                    "
                    [alt]="
                      slotData()?.widget?.data?.offerButton?.clearanceSale
                        ?.title
                    "
                  />
                  <span
                    class="font-medium md:text-xs text-[11px] text-[#ffffff]"
                  >
                    {{
                      slotData()?.widget?.data?.offerButton?.clearanceSale
                        ?.title
                    }}
                  </span>
                </div>
              } @else if (slotData()?.widget?.data?.offerButton?.bulkDiscount) {
                <div
                  class="flex items-center p-[4px] font-medium rounded-[4px] bg-green-200 shadow-sm gap-[5px]"
                >
                  <img
                    class="offer-image"
                    height="15"
                    width="15"
                    [ngSrc]="offerIcon()"
                    class="mt-[2px]"
                    [title]="
                      slotData()?.widget?.data?.offerButton?.bulkDiscount?.text
                    "
                    [alt]="
                      slotData()?.widget?.data?.offerButton?.bulkDiscount?.text
                    "
                  />
                  <span
                    class="font-medium md:text-xs text-[11px] text-green-700"
                  >
                    {{
                      slotData()?.widget?.data?.offerButton?.bulkDiscount?.text
                    }}
                  </span>
                </div>
              }

              @if (slotData()?.widget?.data?.offerButton?.shipsWithin24Hours) {
                <div
                  class="flex items-center p-[4px] font-normal rounded-[4px] bg-red-100 shadow-sm gap-[5px]"
                >
                  <img
                    height="15"
                    width="15"
                    [ngSrc]="shipWithinIcon()"
                    alt="ships within hrs"
                    title="ships within hrs"
                  />
                  <span class="font-medium md:text-xs text-[11px] text-red-800">
                    {{
                      slotData()?.widget?.data?.offerButton?.shipsWithin24Hours
                        ?.text
                    }}
                  </span>
                </div>
              }
              @if (slotData()?.widget?.data?.offerButton?.skuLeadTime) {
                <div
                  class="flex items-center p-[4px] font-normal rounded-[4px] bg-red-100 shadow-sm gap-[5px]"
                >
                  <img height="15" width="15" [ngSrc]="shipWithinIcon()" />
                  <span class="font-medium md:text-xs text-[11px] text-red-800">
                    {{ slotData()?.widget?.data?.offerButton?.skuLeadTime }}
                  </span>
                </div>
              }
            </div>
          }

          @if (
            isPopup() &&
            !isOriginalGridSlot() &&
            !gridViewOnly() &&
            !currentReviewDetails()
          ) {
            <div
              class="flex justify-end -mt-[10px] md:static fixed md:top-auto top-[20px] md:right-auto right-[20px]"
            >
              <button class="cursor-pointer" (click)="popupClose()">
                <img
                  width="18"
                  height="18"
                  [ngSrc]="closePopupIcon()"
                  alt="close"
                  title="close"
                />
              </button>
            </div>
          }

          <div class="h-full flex flex-col">
            @if (!gridViewOnly()) {
              <div
                class="h-full md:h-auto"
                [ngClass]="{ 'md:border-blue-gray-200 h-full': isPopup() }"
              >
                @defer (when swiperLoaded()) {
                  <swiper-container
                    initial-slide="0"
                    slides-per-view="1"
                    [pagination]="{ clickable: true }"
                    [navigation]="{ enabled: true }"
                    (swiperafterinit)="onSwiperInit($event)"
                    (swiperslidechange)="onSwiperSlideChange($event)"
                    class="md:h-[450px] h-[300px]"
                    #swiper
                  >
                    @for (
                      slide of multimediaComponents();
                      track $index;
                      let i = $index
                    ) {
                      <swiper-slide>
                        <div
                          (click)="
                            showAllPhotosModal(
                              $event,
                              slotData()?.widget?.data,
                              i
                            )
                          "
                          class="w-full h-full"
                        >
                          @if (
                            isPopup() && slide.type == MultimediaType.VIDEO
                          ) {
                            <youtube-player
                              [videoId]="slide.value.id"
                              class="object-contain w-full h-full"
                            />
                          } @else {
                            <img
                              class="object-contain w-full h-full"
                              [src]="slide.value.url"
                              [alt]="slotData()?.widget?.data?.title"
                              [title]="slotData()?.widget?.data?.title"
                            />
                          }
                        </div>
                      </swiper-slide>
                    }
                  </swiper-container>
                } @placeholder {
                  <div
                    (click)="
                      showAllPhotosModal($event, slotData()?.widget?.data, 0)
                    "
                    class="cursor-pointer md:h-[450px] h-[300px]"
                  >
                    <img
                      class="object-contain w-full h-full"
                      [src]="skeleton?.value?.url"
                      [alt]="slotData()?.widget?.data?.title"
                      [title]="slotData()?.widget?.data?.title"
                    />
                  </div>
                }

                @if (slotData()?.widget?.data?.multimediaTag?.isDirectImport) {
                  <div
                    class="flex gap-[5px] items-center bg-white bg-opacity-80 px-[8px] py-[4px] rounded-[5px] absolute right-[10px] md:-mt-[60px] -mt-[70px] z-10"
                  >
                    <div class="flex items-center">
                      <img
                        [src]="slotData()?.widget?.data?.multimediaTag?.image"
                        class="w-[25px] h-[25px] object-cover m-auto"
                      />
                    </div>
                    <div
                      class="flex items-center text-[12px] text-[#4F4F4F] font-bold"
                    >
                      {{
                        slotData()?.widget?.data?.multimediaTag?.isDirectImport
                      }}
                    </div>
                  </div>
                }

                @if (slotData()?.widget?.data?.multimediaTag?.isColorVariable) {
                  <div
                    class="flex gap-[5px] items-center bg-white bg-opacity-80 px-[8px] py-[4px] rounded-[5px] absolute right-[10px] md:-mt-[60px] -mt-[70px] z-10"
                  >
                    <div class="flex items-center">
                      <img
                        [src]="slotData()?.widget?.data?.multimediaTag?.image"
                        class="w-[25px] h-[25px] object-cover m-auto"
                      />
                    </div>
                    <div
                      class="flex items-center text-[12px] text-[#4F4F4F] font-bold"
                    >
                      {{
                        slotData()?.widget?.data?.multimediaTag?.isColorVariable
                      }}
                    </div>
                  </div>
                }

                @if (
                  slotData()?.widget?.data?.multimediaTag
                    ?.isImageForRepresentation
                ) {
                  <div
                    class="absolute md:bottom-[90px] bottom-[22px] z-10 text-[12px] left-[10px] right-[10px] flex justify-center -translate-y-[50%]"
                  >
                    <div
                      class="text-center text-[red] py-[5px] md:px-[50px] px-[20px] bg-[#FFF1F3]"
                    >
                      {{
                        slotData()?.widget?.data?.multimediaTag
                          ?.isImageForRepresentation
                      }}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          @if (
            multimediaComponents()?.length > 1 &&
            (gridViewOnly() || showThumbnails())
          ) {
            <div
              class="flex gap-[5px] overflow-auto mt-[5px]"
              [ngClass]="{
                'md:relative fixed md:bottom-auto bottom-[10px] md:inset-x-0 inset-x-[10px] z-40':
                  isPopup() && !gridViewOnly(),
                'grid grid-cols-4 md:grid-cols-6 gap-3 p-4 overflow-y-auto max-h-[100vh]':
                  gridViewOnly(),
              }"
            >
              @for (
                slide of multimediaComponents();
                track $index;
                let i = $index
              ) {
                <div
                  (click)="
                    gridViewOnly() ? launchMultimediaPopup(i) : slideChange(i)
                  "
                  [ngClass]="{
                    'active-thumb': i === activeIndexView() && !gridViewOnly(),
                    'p-1 border border-gray-200 rounded hover:border-gray-500 transition-all cursor-pointer active:border-[#FF9900] min-w-[100px]':
                      !gridViewOnly(),
                    'relative group cursor-pointer rounded-lg overflow-hidden border border-gray-200 hover:border-[#f8660f] transition-all':
                      gridViewOnly(),
                  }"
                >
                  <img
                    [ngClass]="{
                      'object-contain w-full object-center h-[50px]':
                        !gridViewOnly(),
                      'w-full h-full object-cover aspect-square':
                        gridViewOnly(),
                    }"
                    [src]="slide.value.url"
                    [alt]="slide?.value?.alt || slotData()?.widget?.data?.title"
                    [title]="
                      slide?.value?.title || slotData()?.widget?.data?.title
                    "
                  />
                  @if (gridViewOnly()) {
                    <span
                      class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 rounded-lg transition-all"
                    ></span>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
      @if (
        isPopup() &&
        reviewContextEnabled() &&
        currentReviewDetails() &&
        !gridViewOnly()
      ) {
        <div
          class="w-full md:w-[360px] bg-white rounded-md shadow-sm md:shadow-none md:border-l md:border-gray-200"
        >
          <div class="flex flex-col gap-[5px] text-left">
            <div class="flex items-center gap-3 flex-wrap">
              <div
                class="flex items-center text-white text-sm font-semibold px-2.5 py-0.5 rounded-full tracking-wide"
                [style.background-color]="currentReviewDetails()?.badgeColor"
              >
                {{ currentReviewDetails()?.rating }} ★
              </div>

              <p class="text-base font-semibold text-gray-900 break-words">
                {{ currentReviewDetails()?.title }}
              </p>
            </div>
            @if (currentReviewDetails()?.createdRelativeTime) {
              <div class="text-xs text-gray-500">
                {{ currentReviewDetails()?.reviewedText }}:
                {{ currentReviewDetails()?.createdRelativeTime }}
              </div>
            }
            <div
              class="text-sm leading-6 text-gray-700 break-words h-[9rem] overflow-y-auto"
              (click)="
                isReviewExpanded(activeIndexView()) &&
                  toggleReviewText(activeIndexView(), $event)
              "
            >
              {{
                getReviewText(currentReviewDetails()?.text, activeIndexView())
              }}
            </div>
            @if (
              shouldShowReviewToggle(currentReviewDetails()?.text) &&
              !isReviewExpanded(activeIndexView())
            ) {
              <button
                class="text-sm font-semibold text-[#f8660f] hover:text-[#d7550c] w-fit"
                type="button"
                (click)="toggleReviewText(activeIndexView(), $event)"
                [attr.aria-expanded]="isReviewExpanded(activeIndexView())"
              >
                {{ slotData()?.widget?.data?.readMoreText }}
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
  @if (showLoadingBar()) {
    <div
      class="absolute inset-0 flex justify-center items-center z-10 bg-black bg-opacity-20"
    ></div>
  }
</div>
